import React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
export var SunSmartWidget = () => /*#__PURE__*/_jsx("iframe", {
  width: "170",
  height: "300",
  frameBorder: 0,
  scrolling: "no",
  src: "https://www.sunsmart.com.au/uvalert/default.asp?locationid=74",
  allowTransparency: true
});
//# sourceMappingURL=sunsmart_widget.js.map